module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('confirm-base', {
    on: {
      "showErrorModal": function($event) {
        _vm.$emit('showErrorModal', $event)
      },
      "showLoginModal": function($event) {
        _vm.$emit('showLoginModal', $event)
      }
    },
    scopedSlots: _vm._u([
      ["default", function(prop) {
        return [_c('div', {
          staticClass: "form-group p-3"
        }, [_c('label', {
          attrs: {
            "for": "SchoolTitle",
            "co-3": ""
          }
        }, [_vm._v("教室名・タイトル（コース名）"), _c('span', {
          staticClass: "attention"
        }, [_vm._v("※")])]), _vm._v(" "), _c('p', {
          staticClass: "font-weight-bold"
        }, [_vm._v(_vm._s(prop.item.event_name))])]), _vm._v(" "), _c('div', {
          staticClass: "form-group p-3"
        }, [_c('label', {
          attrs: {
            "for": "SchoolTeacher"
          }
        }, [_vm._v("講師名（活動名）"), _c('span', {
          staticClass: "attention"
        }, [_vm._v("※")])]), _vm._v(" "), _c('p', {
          staticClass: "font-weight-bold"
        }, [_vm._v(_vm._s(prop.item.lecturer_name) + "先生")])]), _vm._v(" "), _c('div', {
          staticClass: "form-group p-3"
        }, [_c('label', {
          staticClass: "col-form-label",
          attrs: {
            "for": "Day"
          }
        }, [_vm._v("開催日")]), _vm._v(" "), _c('pre', {
          staticClass: "font-weight-bold"
        }, [_vm._v(_vm._s(prop.item.event_date))])]), _vm._v(" "), _c('div', {
          staticClass: "form-group p-3"
        }, [_c('label', {
          staticClass: "col-form-label",
          attrs: {
            "for": "Event-date-public-input"
          }
        }, [_vm._v("開催日(一覧表示用)"), _c('span', {
          staticClass: "attention"
        }, [_vm._v("※")])]), _vm._v(" "), (prop.item.event_date_public) ? _c('p', {
          staticClass: "font-weight-bold"
        }, [_vm._v(_vm._s(prop.item.event_date_public))]) : _c('pre', {
          staticClass: "font-weight-bold"
        }, [_vm._v(_vm._s(prop.item.event_date_public_multi))]), _vm._v(" "), (!prop.item.event_date_public) ? _c('pre', {
          staticClass: "font-weight-bold"
        }, [_vm._v("開催日の23:59まで掲載されます。")]) : _vm._e()]), _vm._v(" "), (prop.item.event_date_public) ? _c('div', {
          staticClass: "form-group p-3"
        }, [_c('label', {
          staticClass: "col-form-label",
          attrs: {
            "for": "School-dateEnd-input"
          }
        }, [_vm._v("掲載終了日"), _c('span', {
          staticClass: "attention"
        }, [_vm._v("※")])]), _vm._v(" "), _c('p', {
          staticClass: "font-weight-bold"
        }, [_vm._v(_vm._s(prop.endDate))])]) : _vm._e(), _vm._v(" "), _c('div', {
          staticClass: "form-group p-3"
        }, [_c('p', {
          attrs: {
            "for": "SchoolPlace"
          }
        }, [_vm._v("開催場所・住所"), _c('span', {
          staticClass: "attention"
        }, [_vm._v("※")])]), _vm._v(" "), _c('p', {
          staticClass: "font-weight-bold"
        }, [_vm._v(_vm._s(prop.fullAddress))])]), _vm._v(" "), _c('div', {
          staticClass: "form-group p-3"
        }, [_c('label', {
          attrs: {
            "for": "SchoolTel"
          }
        }, [_vm._v("問い合わせ先電話番号")]), _vm._v(" "), _c('p', {
          staticClass: "font-weight-bold"
        }, [_vm._v(_vm._s(prop.item.inquiry.tel))])]), _vm._v(" "), _c('div', {
          staticClass: "form-group p-3"
        }, [_c('label', {
          attrs: {
            "for": "SchoolMail"
          }
        }, [_vm._v("問い合わせ先メールアドレス"), _c('span', {
          staticClass: "attention"
        }, [_vm._v("※")])]), _vm._v(" "), _c('p', {
          staticClass: "font-weight-bold"
        }, [_vm._v(_vm._s(prop.item.inquiry.email))])]), _vm._v(" "), _c('div', {
          staticClass: "form-group p-3"
        }, [_c('label', {
          attrs: {
            "for": "School"
          }
        }, [_vm._v("会場名"), _c('span', {
          staticClass: "attention"
        }, [_vm._v("※")])]), _vm._v(" "), _c('p', {
          staticClass: "font-weight-bold"
        }, [_vm._v(_vm._s(prop.item.venue.venue_name))])]), _vm._v(" "), _c('div', {
          staticClass: "form-group p-3"
        }, [_c('label', {
          attrs: {
            "for": "SchoolURL"
          }
        }, [_vm._v("会場ホームページ（アクセス方法）")]), _vm._v(" "), _c('p', {
          staticClass: "font-weight-bold"
        }, [_vm._v(_vm._s(prop.item.venue.homepage))])]), _vm._v(" "), _c('div', {
          staticClass: "form-group p-3"
        }, [_c('label', {
          attrs: {
            "for": "SchoolBlog"
          }
        }, [_vm._v("講師ホームページ・ブログ記事URL")]), _vm._v(" "), _c('pre', {
          staticClass: "font-weight-bold"
        }, [_vm._v(_vm._s(prop.item.lecturer_url))])]), _vm._v(" "), _c('div', {
          staticClass: "form-group p-3"
        }, [_c('label', {
          attrs: {
            "for": "SchoolDes"
          }
        }, [_vm._v("撮影会詳細")]), _vm._v(" "), _c('pre', {
          staticClass: "font-weight-bold"
        }, [_vm._v(_vm._s(prop.item.description))])]), _vm._v(" "), _c('div', {
          staticClass: "form-group p-3"
        }, [_c('label', {
          attrs: {
            "for": "SchoolPrice"
          }
        }, [_vm._v("参加費")]), _vm._v(" "), _c('div', {
          staticClass: "input-group"
        }, [_c('pre', {
          staticClass: "font-weight-bold"
        }, [_vm._v(_vm._s(prop.item.fee))])])]), _vm._v(" "), _c('div', {
          staticClass: "form-group p-3"
        }, [_c('label', {
          attrs: {
            "for": "AppURL"
          }
        }, [_vm._v("お申し込みURL")]), _vm._v(" "), _c('p', {
          staticClass: "font-weight-bold"
        }, [_vm._v(_vm._s(prop.item.entry_url))])]), _vm._v(" "), _c('div', {
          staticClass: "form-group p-3"
        }, [_c('label', {
          attrs: {
            "for": "SchoolParking"
          }
        }, [_vm._v("駐車場有無")]), _vm._v(" "), _c('p', {
          staticClass: "font-weight-bold"
        }, [_vm._v(_vm._s(prop.item.parking))])]), _vm._v(" "), _c('div', {
          staticClass: "form-group p-3"
        }, [_c('label', {
          attrs: {
            "for": "SchoolImage"
          }
        }, [_vm._v("画像")]), _vm._v(" "), _c('div', {
          staticClass: "row"
        }, _vm._l((prop.item.images.filter(function (i) { return i !== ''; })), function(f) {
          return _c('image-item', {
            key: f,
            attrs: {
              "image": f
            }
          })
        }))]), _vm._v(" "), _c('div', {
          staticClass: "form-group p-3"
        }, [_c('label', {
          attrs: {
            "for": "Schoolpublic"
          }
        }, [_vm._v("公開設定"), _c('span', {
          staticClass: "attention"
        }, [_vm._v("※")])]), _vm._v(" "), _c('p', {
          staticClass: "font-weight-bold"
        }, [_vm._v(_vm._s(prop.item.published))])])]
      }]
    ])
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f1785ddc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/lecturer/event/confirm/SchoolConfirm.vue
// module id = 364
// module chunks = 1